"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StueckpreisVariantComponent = void 0;
var StueckpreisVariantComponent;
(function (StueckpreisVariantComponent) {
    StueckpreisVariantComponent["normal"] = "normal";
    StueckpreisVariantComponent["ek"] = "ek";
    StueckpreisVariantComponent["vk"] = "vk";
})(StueckpreisVariantComponent = exports.StueckpreisVariantComponent || (exports.StueckpreisVariantComponent = {}));
//# sourceMappingURL=StueckpreisVariantComponent.js.map